import createSagaMiddleware from '@redux-saga/core';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer, { authName } from './reducers/authSlice';
import rootSaga from './sagas/rootSaga';
import pageReducer, { pageName } from './reducers/pageSlice';
import mainObjectReducer, { mainObjectName } from './reducers/mainObjectSlice';
import rentalObjectReducer, {
  rentalObjectName,
} from './reducers/rentalObjectSlice';
import userSlice, { userName } from './reducers/userSlice';
import roomSlice, { roomName } from './reducers/roomSlice';
import bookingSlice, { bookingName } from './reducers/bookingSlice';
import pricesSlice, { pricesName } from './reducers/pricesSlice';
import bookingSettingsSlice, {
  bookingSettingsName,
} from './reducers/bookingSettingsSlice';
import tariffsSlice, { tariffsName } from './reducers/tariffsSlice';
import integrationReducer, { integrationName } from './reducers/integrationSlice';
import bookingModuleReducer, {
  bookingModuleName,
} from './reducers/bookingModuleSlice';
import { cleanupMiddleware } from './cleanupMiddleware';

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  [authName]: authReducer,
  [pageName]: pageReducer,
  [mainObjectName]: mainObjectReducer,
  [rentalObjectName]: rentalObjectReducer,
  [userName]: userSlice,
  [roomName]: roomSlice,
  [pricesName]: pricesSlice,
  [bookingSettingsName]: bookingSettingsSlice,
  [bookingName]: bookingSlice,
  [tariffsName]: tariffsSlice,
  [integrationName]: integrationReducer,
  [bookingModuleName]: bookingModuleReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: [sagaMiddleware, cleanupMiddleware],
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;

export default store;
